import MTabs from '@mui/joy/Tabs';
import MTabList from '@mui/joy/TabList';
import MTab from '@mui/joy/Tab';
import MTabPanel from '@mui/joy/TabPanel';

export const Tabs = MTabs;
export const TabList = MTabList;
export const Tab = MTab;
export const TabPanel = MTabPanel;
